import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    FormGroup,
    Input,
    Label,
    Table,
    Spinner,

} from 'reactstrap';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';

import 'jspdf-autotable';
import './ViewExam.css';

const baseURL = apiURL1;

function PromoteStudents() {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newClass, setNewClass] = useState('');
    const [classes, setClasses] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [filterName, setFilterName] = useState("");
    const [filterRegNo, setFilterRegNo] = useState("");
    const [filterEmail, setFilterEmail] = useState("");
    const [filterClass, setFilterClass] = useState("");
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchClasses();
        fetchStudents();
    }, [filterName, filterRegNo, filterEmail, filterClass]);

    const fetchClasses = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/allClassForExam`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setClasses(response.data.data);
        } catch (error) {
            console.error('Error fetching classes:', error);
            toast.error('Error fetching classes');
        }
    };

    const fetchStudents = async () => {
        setLoading(true);
        try {
            let url = `${baseURL}/superadmin/getAllStudents?limit=1000&type=promotion`;
            if (filterName) url += `&fullName=${filterName}`;
            if (filterRegNo) url += `&registrationNumber=${filterRegNo}`;
            if (filterEmail) url += `&email=${filterEmail}`;
            if (filterClass) url += `&classId=${filterClass}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data && response.data.students) {
                setStudents(response.data.students);
            } else {
                setStudents([]);
                toast.warn('No students found with the applied filters.');
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error('Error fetching students');
            setStudents([]);
        } finally {
            setLoading(false);
        }
    };

    const handleCheckboxChange = (studentId) => {
        setSelectedStudents(prev => {
            if (prev.includes(studentId)) {
                return prev.filter(id => id !== studentId);
            } else {
                return [...prev, studentId];
            }
        });
    };

    const handlePromoteSelected = async () => {
        if (selectedStudents.length === 0) {
            toast.warn('Please select at least one student to promote.');
            return;
        }

        if (!newClass) {
            toast.warn('Please select a new class to promote the students to.');
            return;
        }

        setLoading(true);
        try {
            const payload = {
                studentIds: selectedStudents,
                newGrade: newClass
            };
            await axios.put(`${baseURL}/superadmin/promoteStudents`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success('Selected students promoted successfully!');
            fetchStudents();
            setSelectedStudents([]);
        } catch (error) {
            console.error('Error promoting students:', error);
            toast.error('Error promoting students');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (filterType, value) => {
        switch (filterType) {
            case 'name':
                setFilterName(value);
                break;
            case 'regNo':
                setFilterRegNo(value);
                break;
            case 'email':
                setFilterEmail(value);
                break;
            case 'class':
                setFilterClass(value);
                break;
            default:
                break;
        }
    };

    const isPromoteDisabled = selectedStudents.length === 0;

    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <h3>Promote Students</h3>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-3">
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Filter by Name</Label>
                                            <Input
                                                type="text"
                                                placeholder="Enter name"
                                                value={filterName}
                                                onChange={(e) => handleFilterChange('name', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Filter by Reg No</Label>
                                            <Input
                                                type="text"
                                                placeholder="Enter registration number"
                                                value={filterRegNo}
                                                onChange={(e) => handleFilterChange('regNo', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Filter by Email</Label>
                                            <Input
                                                type="email"
                                                placeholder="Enter email"
                                                value={filterEmail}
                                                onChange={(e) => handleFilterChange('email', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Filter by Class</Label>
                                            <Input
                                                type="select"
                                                value={filterClass}
                                                onChange={(e) => handleFilterChange('class', e.target.value)}
                                            >
                                                <option value="">All Classes</option>
                                                {classes.map(cls => (
                                                    <option key={cls._id} value={cls._id}>
                                                        {cls.className}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="6">
                                        <FormGroup>
                                            <Label for="newClass">New Class</Label>
                                            <Input
                                                type="select"
                                                name="newClass"
                                                id="newClass"
                                                value={newClass}
                                                onChange={(e) => setNewClass(e.target.value)}
                                                disabled={isPromoteDisabled}
                                            >
                                                <option value="">Select New Class</option>
                                                {classes.map(cls => (
                                                    <option key={cls._id} value={cls._id}>
                                                        {cls.className}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                        <Button color="primary" onClick={handlePromoteSelected} disabled={loading || isPromoteDisabled}>
                                            {loading ? <Spinner size="sm" /> : 'Promote Selected'}
                                        </Button>
                                    </Col>
                                </Row>
                                <div className="table-responsive">
                                    <Table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                                <th>Select</th>
                                                <th>Registration Number</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Class</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: 'center' }}>
                                                        <Spinner color="primary" />
                                                    </td>
                                                </tr>
                                            ) : students.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5">No students found.</td>
                                                </tr>
                                            ) : (
                                                students.map(student => (
                                                    <tr key={student._id}>
                                                        <td>
                                                            <Input
                                                                type="checkbox"
                                                                checked={selectedStudents.includes(student._id)}
                                                                onChange={() => handleCheckboxChange(student._id)}
                                                            />
                                                        </td>
                                                        <td>{student.registrationNumber}</td>
                                                        <td>{student.fullName}</td>
                                                        <td>{student.email}</td>
                                                        <td>{student.className}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PromoteStudents;
